import Script from "../utils/Script";
import estilo from "./styles/Comentarios.module.css";
import "../index.css";

function Comentarios() {
  return (
    <div className={estilo.Comentarios}>
      <div id="disqus_thread"></div>
      <Script></Script>
      <noscript>
        Please enable JavaScript to view the{" "}
        <a href="https://disqus.com/?ref_noscript">
          comments powered by Disqus.
        </a>
      </noscript>
    </div>
  );
}

export default Comentarios;
